<template>
  <v-data-table
    item-key="id"
    :headers="headers"
    :items="holidays"
    v-bind="this.$attrs"
    :options.sync="tableOptions"
    loading-text="Đang Tải"
    :server-items-length="totalItems"
    :footer-props="footerTable"
    :loading="loading"
    disable-sort
  >
    <template v-slot:[`item.name`]="{ item }">
      {{ item.name }}
    </template>
    <template v-slot:[`item.startDate`]="{ item }">
      {{ item.startDate | ddmmyyyy }}
    </template>
    <template v-slot:[`item.endDate`]="{ item }">
      {{ item.endDate | ddmmyyyy }}
    </template>
    <template v-slot:[`item.createdAt`]="{ item }">
      {{ item.createdAt | ddmmyyyy }}
    </template>
    <template v-slot:[`item.createdAt`]="{ item }">
      {{ item.createdAt | ddmmyyyy }}
    </template>
    <template v-slot:[`item.creator`]="{ item }">
      {{ $_get(item, 'createdBy.name') }}
    </template>
    <template v-slot:[`item.action`]="{ item }">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon small v-bind="attrs" v-on="on">
            <v-icon small>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item @click="onEdit(item)">
            <v-list-item-title>Sửa</v-list-item-title>
          </v-list-item>
          <v-list-item @click="onDelete(item)">
            <v-list-item-title>Xóa</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapState } from 'vuex'

const originHeaders = [
  { text: 'Tên ngày nghỉ', value: 'name' },
  { text: 'Từ ngày', value: 'startDate' },
  { text: 'Đến ngày', value: 'endDate' },
  { text: 'Người tạo', value: 'creator' },
  { text: 'Ngày tạo', value: 'createdAt' },
  { text: 'Thao tác', value: 'action', width: '100px', align: 'center' },
]

export default {
  props: {
    role: String,
  },
  data() {
    return {
      headers: originHeaders,
      draw: false,
      search: '',
      status: null,
      range: { from: null, to: null },
      previewUserId: null,
      ready: false,
      isLoading: false,
      createState: false,
      tableOptions: {},
      interval: null,
    }
  },
  created() {
    this.refresh()
  },
  computed: {
    ...mapState('holiday', ['holidays', 'totalItems', 'pageText', 'loading']),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Số dòng mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 10,
        'page-text': this.pageText,
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    },
  },
  methods: {
    ...mapActions('holiday', ['deleteHoliday', 'requestPageSettings', 'searchHolidays', 'fetchHoliday']),
    async refresh(query) {
      await this.searchHolidays(query)
    },
    onEdit(item) {
      this.$emit('onEdit', item)
    },
    onDelete(item) {
      this.$dialog.confirm({
        title: 'Xác nhận xóa',
        text: `Bạn có chắc chắn muốn xóa ngày nghỉ này?`,
        okText: 'Xóa',
        cancelText: 'Hủy',
        type: 'delete',
        done: async () => {
          try {
            this.$loading.active = true
            await this.deleteHoliday({ id: item.id })
            this.$alert.deleteSuccess()
            this.$loading.active = false
          } catch (e) {
            this.$alert.deleteError()
          }
        },
      })
    },
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage,
          })
        }
      },
      deep: true,
    },
  },
}
</script>
